import { handleAPIError } from "@services/Base";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { CLIENT_API_URL } from "../../../config";
import { ClientModel } from "../types";

export const useClientModels = (client_id: string) => {
  return useQuery({
    queryKey: ["client", client_id, "models"],
    enabled: client_id.length > 0,
    queryFn: ({ signal }) =>
      axios
        .get(
          `${CLIENT_API_URL}/waves-client-manager-api/v1/clients/${client_id}/models`,
          {
            signal
          }
        )
        .then((response) => {
          return response.data as ClientModel[];
        })
        .catch((error) => {
          return handleAPIError(error);
        })
  });
};
